import { Space } from './space.model';
import { Observable } from 'rxjs/Observable';

export class SpaceNamespace {

  namespaceSpace: Observable<string>;
  labelSpace: Observable<string>;

}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
